module.exports = __webpack_public_path__ + "static/media/1 37 interessant.2be1008d.mp3";